function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.86304 1.71363L4.84851 1.56213C4.82784 0.953544 5.26314 0.455415 5.86434 0.39969L6.0152 0.395436L14.5525 0.686656C15.1611 0.707383 15.69 1.17762 15.7868 1.784L15.8004 1.93462L16.0978 10.4764C16.1273 11.1196 15.6483 11.6389 15.008 11.6578C14.3677 11.6767 13.7906 11.1886 13.6951 10.5474L13.6806 10.3959L13.4851 4.77284L2.27938 15.9785C1.86102 16.3968 1.17382 16.4137 0.680188 16.018L0.571077 15.9204C0.123316 15.4727 0.0595765 14.7827 0.422621 14.3149L0.512976 14.2121L11.7212 3.00396L6.09736 2.81098C5.48877 2.79025 4.95984 2.32002 4.86304 1.71363L4.84851 1.56213L4.86304 1.71363Z",
  fill: "white"
});
function SvgRightTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTopArrow);
export default __webpack_public_path__ + "static/media/rightTopArrow.1b52b3c3137a722fe0757f8fd80371f6.svg";
export { ForwardRef as ReactComponent };